import React from "react";
import "./NewBlogs.scss";
import icon from "../../../../assets/icons/crossIcon.svg";

const BlogImagePopper = ({image, onClose}) => {
  return (
    <div
      className="blogImagePopperContainer"
      onClick={onClose}
    >
      <div
        className="blogImagePopperWrapper"
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={onClose}>
          <img
            src={icon}
            alt=""
          />
        </button>
        <img
          src={image}
          alt="Zoomed In"
        />
      </div>
    </div>
  );
};

export default BlogImagePopper;
